import { render, staticRenderFns } from "./allVideos.vue?vue&type=template&id=a5bb1fd0&"
import script from "./allVideos.vue?vue&type=script&lang=js&"
export * from "./allVideos.vue?vue&type=script&lang=js&"
import style0 from "./allVideos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports